// extracted by mini-css-extract-plugin
export default {"content":"AuthRequiredModal_content__2wASI","message":"AuthRequiredModal_message__ETInz"};